import apiClient from './apiConfig';

export const bookingsApi = {
  // Lấy danh sách phiếu thuê. opts: { status, overdue, postId, deleted }
  getAll: async (opts = {}) => {
    const params = {};
    if (opts.status) params.status = opts.status;
    if (opts.overdue) params.overdue = 'true';
    if (opts.postId) params.postId = opts.postId;
    if (opts.deleted) params.deleted = 'true';
    const response = await apiClient.get('/bookings', { params });
    return response.data;
  },

  // Thống kê: { active, overdue, deleted, revenueDate }
  // date: 'YYYY-MM-DD' (giờ VN) để xem thống kê ngày cũ; bỏ trống = hôm nay
  getSummary: async (date) => {
    const params = {};
    if (date) params.date = date;
    const response = await apiClient.get('/bookings/summary', { params });
    return response.data;
  },

  // Doanh thu theo ngày: chỉ trả về khi đúng password (kiểm tra ở backend).
  // Trả về { todayRevenue } hoặc throw nếu sai password.
  getRevenue: async (date, password) => {
    const params = { password };
    if (date) params.date = date;
    const response = await apiClient.get('/bookings/revenue', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/bookings/${id}`);
    return response.data;
  },

  // Tạo phiếu thuê
  create: async (data) => {
    const response = await apiClient.post('/bookings', data);
    return response.data;
  },

  // Cập nhật / gia hạn
  update: async (id, data) => {
    const response = await apiClient.put(`/bookings/${id}`, data);
    return response.data;
  },

  // Kết thúc thuê (trả acc)
  complete: async (id) => {
    const response = await apiClient.patch(`/bookings/${id}/complete`);
    return response.data;
  },

  // Hủy phiếu
  cancel: async (id) => {
    const response = await apiClient.patch(`/bookings/${id}/cancel`);
    return response.data;
  },

  // Khôi phục phiếu đã xóa
  restore: async (id) => {
    const response = await apiClient.patch(`/bookings/${id}/restore`);
    return response.data;
  },

  // Xóa mềm (chuyển vào thùng rác)
  remove: async (id) => {
    const response = await apiClient.delete(`/bookings/${id}`);
    return response.data;
  },

  // Xóa vĩnh viễn
  removePermanent: async (id) => {
    const response = await apiClient.delete(`/bookings/${id}/permanent`);
    return response.data;
  },

  // Thao tác hàng loạt. action: 'complete' | 'cancel' | 'delete' | 'restore' | 'permanent'
  bulk: async (ids, action) => {
    const response = await apiClient.post('/bookings/bulk', { ids, action });
    return response.data;
  },
};
